import { useState, useEffect } from "react";
import { useTitanApp } from "@/hooks/useTitanApp";

const daysMap = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

const transformAvailability = (availability, openingHours) => {
  const base = daysMap.reduce((acc, day) => {
    acc[day] = { enabled: false, timeBlocks: [] };
    return acc;
  }, {});

  if (!Array.isArray(availability)) return base;

  availability.forEach((day) => {
    const dayName = daysMap[day.dayOfWeek];
    const isDayOpenInPharmacy = Array.isArray(openingHours)
      ? openingHours.some(
          (oh) =>
            oh.dayOfWeek === day.dayOfWeek &&
            Array.isArray(oh.slots) &&
            oh.slots.length > 0,
        )
      : false;
    if (!isDayOpenInPharmacy) return;

    base[dayName] = {
      enabled: Array.isArray(day.slots) && day.slots.length > 0,
      timeBlocks: Array.isArray(day.slots)
        ? day.slots.map((s) => ({
            from: s.startTime,
            to: s.endTime,
          }))
        : [],
    };
  });

  return base;
};

const transformOpeningHours = (availability) => {
  const base = daysMap.reduce((acc, day) => {
    acc[day] = { enabled: false, open: null, close: null };
    return acc;
  }, {});
  if (Array.isArray(availability)) {
    availability.forEach((day) => {
      const dayName = daysMap[day.dayOfWeek];
      if (day.slots && day.slots.length > 0) {
        const firstSlot = day.slots[0];
        base[dayName] = {
          enabled: true,
          open: firstSlot.startTime,
          close: firstSlot.endTime,
        };
      }
    });
  }
  return base;
};

export const useLocationsSettingsData = () => {
  const [initialLocations, setInitialLocations] = useState([]);
  const { appState, locationState } = useTitanApp();
  const { darkMode } = appState || {};
  const { allPharmacies, isPharmacyServiceLoading } = locationState || {};
  useEffect(() => {
    if (allPharmacies) {
      setInitialLocations(
        allPharmacies.map((pharmacy) => ({
          id: pharmacy?.pharmacyID,
          name: pharmacy?.pharmacyName || "",
          address: pharmacy?.pharmacyAddress || "",
          active: pharmacy.active,
          rooms: (pharmacy.pharmacyRooms || []).map((room) => ({
            id: room._id,
            name: room.roomName,
            services: room.services?.map((s) => s.serviceName) || [],
            availability: transformAvailability(
              room.availability,
              pharmacy.openingHours,
            ),
            active: room.active,
          })),
          email: pharmacy?.emailAddress || "",
          phone: pharmacy?.phoneNumber || "",
          openingHours: transformOpeningHours(pharmacy.openingHours),
        })),
      );
    }
  }, [allPharmacies]);
  return {
    initialLocations,
    darkMode,
    isPharmacyServiceLoading,
  };
};
